<template>
  <div class="download_app">
    <div class="download_app_top">
      <img :src="userLogo" alt="" />
      <div>畅居家园</div>
    </div>
    <div class="download_app_bottom">
      <div>请点击右上角分享按钮 “ ··· ” 在浏览器中打开</div>
      <a :href="uploadUrl">
        <img :src="downloadUserApp" alt="" />
      </a>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";
import axios from "axios"; //引入

import downloadUserApp from "../../../assets/downloadApp/downloadUserApp.png";
import downloadBack from "../../../assets/downloadApp/downloadBack.png";
import userLogo from "../../../assets/downloadApp/userLogo.png";

export default {
  setup() {
    return reactive({
      downloadUserApp: downloadUserApp,
      downloadBack: downloadBack,
      userLogo: userLogo,
      uploadUrl: "",
    });
  },
  created() {
    axios
      .get("http://shcywy.cn:8080/sys/soft/message?category=1")
      .then((res) => {
        console.log(res);
        this.uploadUrl = res.data.data.softAddress;
      });
  },
};
</script>

<style scoped>
.download_app {
  width: 100%;
  height: 100vh;
  text-align: center;
  background-image: url(../../../assets/downloadApp/downloadBack.png);
  background-size: cover;
  background-position: center center;
  border-radius: 4px 4px 4px 4px;
  position: relative;
}
.download_app_top {
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translateX(-50%);
}
.download_app_top img {
  width: 88px;
}
.download_app_top div {
  margin-top: 24px;
  font-size: 18px;
  font-weight: 550;
  color: #19367b;
}
.download_app_bottom {
  position: absolute;
  bottom: 20%;
}
.download_app_bottom div {
  font-size: 14px;
  color: #8fb9f7;
}
.download_app_bottom img {
  width: 80%;
  margin-top: 30px;
}
</style>
